export enum ProvinciaItalia {
  AGRIGENTO = "Agrigento",
  ALESSANDRIA = "Alessandria",
  ANCONA = "Ancona",
  AOSTA = "Aosta",
  AREZZO = "Arezzo",
  ASCOLIPICENO = "Ascoli Piceno",
  ASTI = "Asti",
  AVELLINO = "Avellino",
  BARI = "Bari",
  BARLETTAANDRIATRANI = "Barletta-Andria-Trani",
  BELLUNO = "Belluno",
  BENEVENTO = "Benevento",
  BERGAMO = "Bergamo",
  BIELLA = "Biella",
  BOLOGNA = "Bologna",
  BOLZANO = "Bolzano",
  BRESCIA = "Brescia",
  BRINDISI = "Brindisi",
  CAGLIARI = "Cagliari",
  CALTANISSETTA = "Caltanissetta",
  CAMPOBASSO = "Campobasso",
  CARBONIAIGLESIAS = "Carbonia-Iglesias",
  CASERTA = "Caserta",
  CATANIA = "Catania",
  CATANZARO = "Catanzaro",
  CHIETI = "Chieti",
  COMO = "Como",
  COSENZA = "Cosenza",
  CREMONA = "Cremona",
  CROTONE = "Crotone",
  CUNEO = "Cuneo",
  ENNA = "Enna",
  FERMO = "Fermo",
  FERRARA = "Ferrara",
  FIRENZE = "Firenze",
  FOGGIA = "Foggia",
  FORLICESANA = "Forlì-Cesena",
  FROSINONE = "Frosinone",
  GENOVA = "Genova",
  GORIZIA = "Gorizia",
  GROSSETO = "Grosseto",
  IMPERIA = "Imperia",
  ISERNIA = "Isernia",
  LASPEZIA = "La Spezia",
  LAQUILA = "L'Aquila",
  LATINA = "Latina",
  LECCE = "Lecce",
  LECCO = "Lecco",
  LIVORNO = "Livorno",
  LODI = "Lodi",
  LUCCA = "Lucca",
  MACERATA = "Macerata",
  MANTOVA = "Mantova",
  MASSACARRARA = "Massa-Carrara",
  MATERA = "Matera",
  MEDIOCAMPIDANO = "Medio Campidano",
  MESSINA = "Messina",
  MILANO = "Milano",
  MODENA = "Modena",
  MONZAEBRIANZA = "Monza e della Brianza",
  NAPOLI = "Napoli",
  NOVARA = "Novara",
  NUORO = "Nuoro",
  OGLIASTRA = "Ogliastra",
  OLBIA_TEMPIO = "Olbia-Tempio",
  ORISTANO = "Oristano",
  PADOVA = "Padova",
  PALERMO = "Palermo",
  PARMA = "Parma",
  PAVIA = "Pavia",
  PERUGIA = "Perugia",
  PESAROEURBINO = "Pesaro e Urbino",
  PESCARA = "Pescara",
  PIACENZA = "Piacenza",
  PISA = "Pisa",
  PISTOIA = "Pistoia",
  PORDENONE = "Pordenone",
  POTENZA = "Potenza",
  PRATO = "Prato",
  RAGUSA = "Ragusa",
  RAVENNA = "Ravenna",
  REGGIOCALABRIA = "Reggio Calabria",
  REGGIOEMILIA = "Reggio Emilia",
  RIETI = "Rieti",
  RIMINI = "Rimini",
  ROMA = "Roma",
  ROVIGO = "Rovigo",
  SALERNO = "Salerno",
  SASSARI = "Sassari",
  SAVONA = "Savona",
  SIENA = "Siena",
  SIRACUSA = "Siracusa",
  SONDRIO = "Sondrio",
  TARANTO = "Taranto",
  TERAMO = "Teramo",
  TERNI = "Terni",
  TORINO = "Torino",
  TRAPANI = "Trapani",
  TRENTO = "Trento",
  TREVISO = "Treviso",
  TRIESTE = "Trieste",
  UDINE = "Udine",
  VARESE = "Varese",
  VENEZIA = "Venezia",
  VERBANOCUSIOOSSOLA = "Verbano-Cusio-Ossola",
  VERCELLI = "Vercelli",
  VERONA = "Verona",
  VIBOVALENTIA = "Vibo Valentia",
  VICENZA = "Vicenza",
  VITERBO = "Viterbo",
}

export const provincieItaliaList: ProvinciaItalia[] =
  Object.values(ProvinciaItalia);

export const SediPerCode = {
  1: "Roma",
  8: "Borgaro Torinese",
  31: "Treviso",
  6: "Torino",
  18: "Milano",
  41: "Genova",
  317: "Monza",
  203: "Modena",
};

export const sediPerProvincia = {
  [ProvinciaItalia.MILANO]: [18],
  [ProvinciaItalia.ROMA]: [1],
  [ProvinciaItalia.TORINO]: [8, 6],
  [ProvinciaItalia.GENOVA]: [41],
  [ProvinciaItalia.MONZAEBRIANZA]: [317],
  [ProvinciaItalia.TREVISO]: [31],
  [ProvinciaItalia.MODENA]: [203],
};

export const provinciaPerSede = {
  "Borgaro Torinese": ProvinciaItalia.TORINO,
  Treviso: ProvinciaItalia.TREVISO,
  Torino: ProvinciaItalia.TORINO,
  Milano: ProvinciaItalia.MILANO,
  Genova: ProvinciaItalia.GENOVA,
  Monza: ProvinciaItalia.MONZAEBRIANZA,
  Roma: ProvinciaItalia.ROMA,
  Modena: ProvinciaItalia.MODENA,
};

export type SedeOption = {
  label: string;
  value: string;
  codes: number[];
};

export const sediOptionsList: SedeOption[] = Object.entries(SediPerCode).map(
  ([code, name]) => ({
    label: name,
    value: String(code),
    codes: [Number(code)],
  })
);

export const getSedeOptionByValue = (sedeValue: string) =>
  sediOptionsList.find((option) => option.value === sedeValue);

export const getSedeCityNames = (codes: number[]): string[] =>
  codes
    .map((code) => SediPerCode[code as keyof typeof SediPerCode])
    .filter((city): city is string => Boolean(city));

export const getSedeCodesForValue = (sedeValue: string): string[] => {
  const option = getSedeOptionByValue(sedeValue);
  if (!option) return [];
  return option.codes.map(String);
};

export const getSedeCodesForValues = (
  sedeValues: string | string[] | null | undefined
): string[] => {
  if (!sedeValues) return [];
  const values = Array.isArray(sedeValues)
    ? sedeValues
    : sedeValues.split(",");
  const codes = new Set<string>();
  for (const value of values) {
    const trimmed = value.trim();
    if (!trimmed) continue;
    for (const code of getSedeCodesForValue(trimmed)) {
      codes.add(code);
    }
  }
  return Array.from(codes);
};

export const getProvincesForSedeCodes = (codes: string[]): string[] => {
  const provinces = new Set<string>();
  for (const code of codes) {
    const numericCode = Number(code);
    if (!Number.isFinite(numericCode)) continue;
    for (const [provincia, provinciaCodes] of Object.entries(sediPerProvincia)) {
      if (provinciaCodes.includes(numericCode)) {
        provinces.add(provincia);
        break;
      }
    }
  }
  return Array.from(provinces);
};

export const matchesWorkerSede = (
  worker: Record<string, unknown>,
  sedeValue: string | string[] | null
): boolean => {
  const sedeCodes = getSedeCodesForValues(sedeValue);
  if (sedeCodes.length === 0) return true;

  const codUff = worker.COD_UFF ?? worker.sede;
  if (codUff != null && codUff !== "") {
    return sedeCodes.includes(String(codUff));
  }

  const isPlacementUser =
    worker.placement_user === true ||
    worker.placement_user === "true" ||
    String(worker.placement_user).toLowerCase() === "true";

  if (isPlacementUser) {
    const provinces = getProvincesForSedeCodes(sedeCodes);
    const workerProvincia = worker.provincia?.toString() ?? "";
    return provinces.includes(workerProvincia);
  }

  const workerCity = worker.citta?.toString().toLowerCase() ?? "";
  return getSedeCityNames(sedeCodes.map(Number)).some(
    (city) => workerCity === city.toLowerCase()
  );
};
